(() => {
  const sizeKey = value => /zip|super/i.test(value) ? 'superking' : String(value).toLowerCase().replace(/[^a-z]/g, '');
  class Protector extends HTMLElement {
    connectedCallback() {
      this.protectors = JSON.parse(this.querySelector('[data-protector-variants]').textContent);
      this.mattresses = JSON.parse(this.querySelector('[data-mattress-variants]').textContent);
      this.sizeIndex = JSON.parse(this.querySelector('[data-mattress-options]').textContent).findIndex(x => /size/i.test(x));
      this.section = this.closest('.shopify-section');
      this.refresh = () => this.update();
      this.section.addEventListener('change', this.refresh);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.section, { subtree: true, childList: true, attributes: true, attributeFilter: ['value'] });
      this.update();
    }
    disconnectedCallback() { this.section?.removeEventListener('change', this.refresh); this.observer?.disconnect(); }
    match(id) {
      const variant = this.mattresses.find(v => String(v.id) === String(id));
      if (!variant || this.sizeIndex < 0) return null;
      return this.protectors.find(p => sizeKey(p.option1) === sizeKey(variant.options[this.sizeIndex]));
    }
    update() {
      const id = this.section.querySelector('product-form-component form [name="id"]')?.value;
      const variant = this.match(id);
      const checkbox = this.querySelector('input');
      checkbox.disabled = !variant?.available;
      if (checkbox.disabled) checkbox.checked = false;
      const price = variant ? new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 }).format(variant.price / 100) : '';
      const label = this.querySelector('[data-protector-price]');
      if (label.textContent !== price) label.textContent = price;
      const status = this.querySelector('[data-protector-status]');
      const message = variant?.available ? '' : 'A matching protector is currently unavailable.';
      if (status.textContent !== message) status.textContent = message;
    }
  }
  if (!customElements.get('tms-protector')) customElements.define('tms-protector', Protector);
  window.TMSProtector = {
    prepare(component, data) {
      const block = component.closest('.shopify-section')?.querySelector('tms-protector');
      if (!block?.querySelector('input:checked')) return data;
      const protector = block.match(data.get('id'));
      if (!protector?.available) throw new Error('Please choose an available mattress protector.');
      const paired = new FormData();
      for (const [name, value] of data.entries()) {
        if (name === 'sections' || name === 'sections_url') paired.set(name, value);
      }
      // Explicitly construct nested names to preserve product properties and selling plans.
      for (const [name, value] of data.entries()) {
        if (name === 'sections' || name === 'sections_url') continue;
        const bracket = name.indexOf('[');
        const nested = bracket < 0 ? `items[0][${name}]` : `items[0][${name.slice(0, bracket)}]${name.slice(bracket)}`;
        paired.append(nested, value);
      }
      paired.set('items[1][id]', protector.id);
      paired.set('items[1][quantity]', data.get('quantity') || '1');
      return paired;
    }
  };
})();
